{
  "route.actions.title": "操作",
  "actionSetupTierFields.multiplyPointsEnabled.label.points": "多倍积分",
  "actionSetupTierFields.multiplyPointsEnabled.label.points.loyalty": "多倍积分",
  "actionSetupTierFields.multiplyPointsEnabled.label.points.status": "多状态积分",
  "actionSetupTierFields.multiplyPointsEnabled.label.points.balance": "多倍消费积分",
  "actionSetupTierFields.multiplyPointsEnabled.label.spend": "多倍业绩",
  "actionSetupTierFields.multiplyPoints.placeholder": "-- 选择倍数 --",
  "actionSetupTierFields.pointsEnabled.label.points": "奖励积分",
  "actionSetupTierFields.pointsEnabled.label.points.loyalty": "奖励积分",
  "actionSetupTierFields.pointsEnabled.label.points.status": "奖励状态积分",
  "actionSetupTierFields.pointsEnabled.label.points.balance": "可消费的奖励积分",
  "actionSetupTierFields.pointsEnabled.label.spend": "额外积分",
  "actions.addButton.text": "创建此类型新操作：{actionType}",
  "actionSetup.title.new": "新建：{actionType}",
  "actionSetup.title.edit": "{actionType} 设置 - {actionName}",
  "actionSetup.referralContent.referrer.text": "对于每个首次使用您的优惠代码下单的朋友，您将获得：{token}。",
  "actions.notification.purchase.helpLinkText": "附加",
  "actions.notification.purchase.learnMoreLinkText": "了解更多",
  "actions.notification.promotion.learnMoreLinkText": "了解更多",
  "actions.notification.promotion": "在设置促销之前，请务必查看帮助文档以了解您的设置如何影响客户体验。{learnMoreLink}。",
  "actions.notification.engagement.helpLinkText": "附加",
  "actions.notification.engagement.learnMoreLinkText": "了解更多",
  "actions.notification.event.learnMoreLinkText": "了解更多",
  "actions.notification.event": "为使事件操作变为活动状态，您需要将其连接到自动化程序。{learnMoreLink}。",
  "actions.notification.referral.learnMoreLinkText": "了解更多",
  "actions.notification.referral": "您可以为每个市场创建一个推荐操作。{learnMoreLink}。",
  "actions.notification.join.helpLinkText": "附加",
  "actions.notification.join.learnMoreLinkText": "了解更多",
  "actionSetup.alert.activeMustDeactivate": "此操作处于活动状态，其设置已锁定。要编辑此操作，您必须先执行以下操作：{deactivateTag}并等待过期日期。",
  "actions.deleteAction.tooltip.attachable": "要删除操作，您必须先取消激活该操作并等待过期日期。",
  "actions.deleteAction.tooltip.promotion": "要删除活动的促销操作，您必须先将其取消激活。",
  "actions.deleteAction.tooltip.event": "要删除活动的事件操作，您必须先将其取消激活。",
  "actions.reportsIcon.tooltip": "程序分析",
  "actions.card.subtitle.starttime": "开始日期：{startTime}",
  "actions.card.subtitle.endtime": "结束日期：{endTime}",
  "actions.card.subtitle.nonPromotion.suffix": "操作",
  "actions.card.label.recurring": "经常性",
  "actions.card.label.nonRecurring": "非经常性",
  "actions.masterActions.join.largeText": "加入忠诚度",
  "actions.masterActions.purchases.largeText": "购买",
  "actions.masterActions.engagements.largeText": "参与",
  "actions.masterActions.events.largeText": "事件",
  "actions.masterActions.promotions.largeText": "促销",
  "actions.masterActions.referral.largeText": "推荐人",
  "actions.deleteDialog.attachable.title": "是否确定要删除此操作？",
  "actions.deleteDialog.attachable.text": "删除此操作之前，请确保它未连接到任何自动化程序。删除此操作后，它将不再可用。",
  "actions.deleteDialog.promotion.title": "是否确定要删除此促销？",
  "actions.deleteDialog.promotion.text": "删除此促销之前，请确保它未连接到任何自动化程序。删除此促销后，它将不再可用。",
  "actions.deleteDialog.event.title": "是否确定要删除此操作？",
  "actions.deleteDialog.event.text": "删除此操作之前，请确保它未连接到任何自动化程序。删除此操作后，它将不再可用。",
  "actions.deleteDialog.referral.title": "是否确实要删除该计划？",
  "actions.deleteDialog.referral.text": "删除此计划后，该计划及其设置将不可用。请务必告知会员该计划不再可用。",
  "actions.filters.search.label": "搜索",
  "actions.filters.status.label": "状态",
  "actions.filters.usageType.label": "使用类型",
  "actions.filters.recurringType.label": "经常性类型",
  "actions.addButton.promotion.text": "创建新促销",
  "actionSetup.title.default": "缺省设置",
  "actionSetup.referralContent.referrer.title": "奖励您的朋友：",
  "actionSetup.referralContent.referrer.subtitle": "分享您的个人链接：",
  "actionSetup.referralContent.referrer.consentText": "通过分享您的个人链接，您同意：",
  "actionSetup.referralContent.referrer.consentLinkText": "条款和条件",
  "actionSetup.alert.promotionEnded": "此促销活动已过期，无法编辑。您可以复制促销活动或创建新促销活动。",
  "actionSetup.alert.notActivated": "操作在过期日期前处于活动状态：{timeTag}",
  "actionSetup.rewardSetting.notification.purchaseAction": "未定义奖励的层级会员将收到缺省消息。新会员将收到缺省注册消息和奖励。",
  "actionSetup.rewardSetting.notification.eventAction": "未定义奖励的层级会员将收到缺省消息。",
  "actionSetup.rewardSetting.notification.promotionAction": "未定义奖励的层级会员将收到缺省操作消息。",
  "actionSetup.actionSettings.notification.engagementAction": "所有参与操作均由自动化中心程序触发。",
  "actionSetup.actionSettings.notification.eventAction": "所有事件操作均由自动化中心程序触发。您定义的奖励将显示在 Loyalty Wallet 中的兑换页面上。",
  "actionSetup.actionSettings.notification.referralAction": "在设置程序之前，请务必创建要连接的触发电子邮件营销活动。如果您管理多种语言的计划，为每种语言创建模板。<a target=\"_blank\" href=\"https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdeef4f574c11014a278956df7fe0479.html?locale=en-US\">了解更多</a>",
  "actionSetup.referralContent.referee.title": "获取您的奖励！",
  "actionSetup.referralContent.referee.text": "恭喜，您的朋友给您送了一份礼物。",
  "actionSetup.referralContent.referee.secondaryTitle": "输入您的电子邮件以兑换您的奖励。",
  "actionSetup.referralContent.referee.secondaryText": "我们使用您的电子邮件来兑现您的奖励并确保您收到它",
  "actionSetup.referralContent.referee.inputFieldPlaceholder": "输入您的电子邮件。",
  "actionSetup.referralContent.referee.consentText": "我同意：",
  "actionSetup.referralContent.referee.consentLinkText": "条款和条件",
  "actionSetup.multilangActionNameField.label": "操作名称",
  "actionSetup.multilangPopup.title": "基于语言触发的电子邮件营销活动",
  "actionSetupContentCreation.editSide.notification.contnet": "事件操作仅在附加后显示在 Loyalty Wallet 的兑换页面上。积分会自动添加到会员余额中。",
  "actionSetupContentCreation.editSide.title.text.default": "缺省消息  ",
  "actionSetupContentCreation.editSide.title.text.loyalty": "忠诚度消息",
  "actionSetupContentCreation.editSide.title.text.realtime": "实时通知",
  "actionSetupContentCreation.editSide.title.tooltip.event": "事件操作由自动化中心程序触发。您定义的奖励将自动提供给会员。您可以在任何市场营销渠道中使用定义的令牌。",
  "actionSetupContentCreation.previewSideTitleTooltip.conent": "定义的操作和奖励如何在电子邮件内容块中显示的示例。实际设计可能因您的电子邮件设计而异。",
  "actionSetupContentCreation.nav.loyaltyMessage": "忠诚度消息",
  "actionSetupContentCreation.nav.realtimeMessage": "实时通知",
  "actionSetupContentCreation.preview.title": "预览",
  "actionSetupContentCreation.previewTabs.tooltip.message": "消息预览",
  "actionSetupContentCreation.previewTabs.tooltip.tiers": "层级预览",
  "actionSetupContentCreation.previewTabs.tooltip.wallet": "钱包预览",
  "actionSetupGeneral.triggerConnection.tooltip.engagement": "参与操作由自动化中心程序触发。从列表中选择完成此操作所需的所有相关外部事件。",
  "actionSetupGeneral.triggerConnection.tooltip.event": "事件操作由自动化中心程序触发。从列表中选择完成此操作所需的相关外部忠诚度事件。",
  "actionSetupGeneral.triggerConnection.label": "外部忠诚度事件",
  "actionSetupGeneral.triggerConnection.placeholder": "-- 选择连接 --",
  "actionSetupGeneral.promotionSetting.promotionTypeRb.label": "促销类型",
  "actionSetupGeneral.promotionSetting.automaticTargeting.label": "自动定位",
  "actionSetupGeneral.promotionSetting.automaticTargeting.tooltip": "您可以单独使用自动定位，也可以在营销活动编辑器中推送促销时使用。",
  "actionSetupGeneral.promotionSetting.automaticTargeting.showInWalletCb.label": "自动将此促销定位到相关层级会员并将其显示在他们的 Loyalty Wallet 中。",
  "actionSetupGeneral.promotionSetting.automaticTargeting.notification": "实时编辑您的促销并将更改推送到 Loyalty Wallet。这为您提供了灵活性，但如果您还使用电子邮件推送此促销，则可能会导致不一致。<a href=\"https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdea82a574c11014b4ab87b7d9fc9306.html?locale=en-US\" target=\"_blank\">了解更多。</a>",
  "actionSetupGeneral.promotionSetting.title": "促销设置",
  "actionSetupGeneral.actionNameInput.defNoJoin.label": "缺省类型",
  "actionSetupGeneral.actionNameInput.referral.label": "程序名称",
  "actionSetupGeneral.actionInternalNameInput.referral.label": "内部计划名称",
  "actionSetupGeneral.actionNameInput.referral.tooltip": "输入计划名称，以在会员的活动历史记录中显示。该名称还可在内部识别该计划。",
  "actionSetupGeneral.title": "常规设置",
  "actionSetupGeneral.multiMarketSelect.label": "选择市场",
  "actionSetupGeneral.multiMarketSelect.tooltip": "忠诚度设置中的“语言和货币”标签中定义的市场。您必须为每个市场定义单独的计划，该计划和推荐链接仅显示在所选市场的 Loyalty Wallet 中。每个市场只能设置一个计划。",
  "actionSetupGeneral.actionTypeSelect.label": "选择用例",
  "actionSetupGeneral.catalogSelectorInput.label": "从目录中选择",
  "actionSetupGeneral.catalogSelectorInput.title": "目录选择器",
  "actionSetupGeneral.catalogSelectorInput.tooltip": "选择您要促销的特定产品、类别或系列。",
  "actionSetupGeneral.defaultJoinInput.label": "缺省类型",
  "actionSetupGeneral.defaultJoinInput.value": "缺省连接",
  "actionSetupGeneral.descriptionInput.label": "内部描述",
  "actionSetupGeneral.iconSelectInput.label": "图标",
  "actionSetupGeneral.iconSelectInput.iconText": "添加到操作",
  "actionSetupGeneral.iconSelectInput.tooltip": "选择向会员显示的图标。该图标还会在个性化服务中显示为忠诚度令牌。",
  "actionSetupGeneral.minOrderInput.label": "最低订单金额",
  "actionSetupGeneral.minOrderInput.tooltip.referral": "如果您定义此值，则被推荐的朋友必须在其订单中至少花费此金额，推荐会员才能获得奖励。请务必将此信息包含在您向会员和朋友发送的推荐消息中。",
  "actionSetupGeneral.minOrderInput.tooltip.other": "会员必须在其订单中至少花费此金额，才能获得奖励。请务必将此信息包含在您的操作消息中。",
  "actionSetupGeneral.minOrderDisplayInput.label": "显示金额",
  "actionSetupGeneral.minOrderDisplayInput.tooltip": "如果客户的总消费额与最低订单金额不匹配（例如，在考虑第三方费用后），客户将看到的金额。",
  "actionSetupGeneral.blockExternalLink.url.label": "外部 URL",
  "actionSetupGeneral.blockExternalLink.url.tooltip": "您可以添加 URL，该 URL 可直接从 Loyalty Wallet 中的操作块链接到某个页面。",
  "actionSetupGeneral.blockExternalLink.text.label": "URL 文本",
  "actionSetupGeneral.blockExternalLink.text.tooltip": "输入此 URL 的文本，该文本会显示给 Loyalty Wallet 中的会员。",
  "actionSetupGeneral.actionNameInput.other.label": "{actionTypeText} 的名称",
  "actionSetupGeneral.actionInternalNameInput.other.label": "{actionTypeText} 的内部名称",
  "actionSetupGeneral.actionNameInput.other.tooltip": "输入要显示给会员的名称：{actionTypeText}。该名称还会在个性化服务中显示为忠诚度令牌。",
  "actionSetupLoyaltyMessage.tooltip.members.nonDefault": "此消息将显示给会员：{actionTypeText}。此令牌包括奖励令牌。",
  "actionSetupLoyaltyMessage.ctaButton.tooltip": "此调用操作用于 Loyalty Wallet 中兑换页面上的所有条目。",
  "actionSetupLoyaltyMessage.ctaButton.label": "调用操作",
  "actionSetupLoyaltyMessage.ctaUrl.label": "调用操作 URL",
  "actionSetupLoyaltyMessage.ctaUrl.tooltip.eventAction": "调用操作 URL 可用作任何渠道中的个性化令牌，但无法在钱包或通过 API 使用。",
  "actionSetupLoyaltyMessage.header.members": "会员",
  "actionSetupLoyaltyMessage.header.nonMembers": "非会员",
  "actionSetupLoyaltyMessage.label.join": "加入消息",
  "actionSetupLoyaltyMessage.label.other": "消息",
  "actionSetupLoyaltyMessage.tooltip.nonmembers.hasRewardForNonMembers": "您已经定义了奖励，缺省消息显示在此处。您可以编辑奖励和消息。",
  "actionSetupLoyaltyMessage.tooltip.nonmembers.noRewardForNonMembers": "您没有定义新成员的奖励，因此缺省加入消息和奖励显示在此处。无法编辑。",
  "actionSetupLoyaltyMessagePreviewEmail.notification.contentMode": "定义的操作和奖励如何在电子邮件内容块中显示的示例。实际设计可能因您的电子邮件设计而异。",
  "actionSetupLoyaltyMessageTokens.notification.content": "内容编辑器中所有渠道可用的忠诚度令牌列表。",
  "actionSetupRealtimeNotification.content.notification.url.label": "实时 Web 通知 URL",
  "actionSetupRealtimeNotification.content.notification.url.tooltip": "输入通知显示的页面的 URL。",
  "actionSetupRealtimeNotification.content.notification.limitOfUse.label": "限制使用",
  "actionSetupRealtimeNotification.content.notification.limitOfUse.tooltip": "选择您希望此通知显示的频率。",
  "actionSetupReferralContent.title": "推荐表单",
  "actionSetupReferralContent.translateForm.label": "翻译表单 ",
  "actionSetupReferralContent.translateForm.tooltip": "表单翻译是可选的。如果没有可用翻译，则表单将以您在忠诚度设置中定义的缺省语言显示给会员。",
  "actionSetupReferralContent.preview": "预览",
  "actionSetupRewards.pointsType.title": "奖励积分类型",
  "actionSetupRewards.pointsType.tooltip": "定义完成操作后奖励的积分类型。",
  "actionSetupRewards.pointsType.popup.title": "是否确定？",
  "actionSetupRewards.title": "奖励",
  "actionSetupRewards.tooltip": "定义此操作赢得的奖励。",
  "actionSetupRewards.accordionTierItem.tooltip.all.disabled": "无法为此操作提供以下积分类型的“多倍积分”奖励：{pointType}。以下层级缺省不支持此积分类型：({tierNames})。更新这些层级，或选择其他奖励类型。",
  "actionSetupRewards.accordionTierItem.tooltip.tier.disabled": "无法提供“多倍积分”奖励，因为此层级不支持以下基本购买积分类型：{pointType}",
  "actionSetupRewards.accordionTierItem.tooltip.pointType.status": "状态积分",
  "actionSetupRewards.accordionTierItem.tooltip.pointType.balance": "消费积分",
  "actionSetupRewards.subtitle.members": "忠诚度会员奖励",
  "actionSetupRewards.subtitle.friends": "好友奖励",
  "actionSetupRewards.subtitle.friends.tooltip": "此处的“好友”是指任何从忠诚度会员处获得推荐的人。",
  "actionSetupRewards.accordionTierItem.tooltip.non": "除了加入忠诚度计划的标准奖励外，还为会员提供附加购买奖励。",
  "actionSetupRewards.accordionTierItem.tooltip.all": "这将覆盖任何个人层级奖励。",
  "actionSetupRewards.referralLimitations.codes.type.title": "限制推荐代码",
  "actionSetupRewards.referralLimitations.codes.type.tooltip": "限制忠诚度会员一年内可以发送给朋友的代码数量。此设置有助于降低欺诈性使用的风险。",
  "actionSetupRewards.referralLimitations.rewards.type.label": "限制推荐奖励",
  "actionSetupRewards.referralLimitations.rewards.type.tooltip": "限制忠诚度会员一年内可以获得推荐奖励的次数。",
  "actionTypeOptions.purchase.name": "促进购买",
  "actionTypeOptions.promotioEvent.name": "销售/事件",
  "actionTypeOptions.promotioCatalog.name": "目录促销",
  "actionTypeOptions.engagement.name": "促进互动",
  "actionTypeOptions.event.name": "周年纪念日/福利日",
  "actionTypeOptions.redemption.name": "促进积分兑换",
  "actionTypeOptions.referral.name": "推荐人",
  "actionTypeOptions.join.name": "加入忠诚度计划",
  "defaultActionTypeOptions.join.name": "加入忠诚度计划/忠诚度缺省",
  "defaultActionTypeOptions.purchases.name": "购买/忠诚度缺省",
  "defaultActionTypeOptions.promotionEvent.name": "销售/事件",
  "defaultActionTypeOptions.promotionCatalog.name": "目录促销",
  "defaultActionTypeOptions.engagements.name": "参与/忠诚度缺省值",
  "defaultActionTypeOptions.events.name": "奖金/忠诚度缺省值",
  "defaultActionTypeOptions.redemption.name": "兑换/忠诚度缺省值",
  "actionSetupScheduling.rewardsAllocationDelay.duration.tooltip.NoDelay": "在计划设置中定义。",
  "actionSetupScheduling.rewardsAllocationDelay.duration.tooltip.withDelay": "选择会员完成操作后多久将奖励添加到会员 Loyalty Wallet。",
  "actionSetupScheduling.activationTooltip.promotionDispalyedInWallet": "如果您取消激活此促销活动，它将从 Loyalty Wallet 中删除，并且您无法在所有渠道上使用该促销活动，直到您再次激活它。",
  "actionSetupScheduling.activationTooltip.referral": "如果您取消激活该计划，推荐链接将不再有效，并会阻止 Loyalty Wallet 中的推荐类别，直到您重新激活它。如果优惠券代码已经提供给朋友，则在过期日期之前仍然有效。",
  "actionSetupScheduling.activationTooltip.default": "如果您取消激活此操作，您将无法在所有渠道上分发它，直到您再次激活它。如果此操作连接到自动程序，则自动程序将失败。如果操作已经提供给客户，则在过期日期之前仍然有效。",
  "actionSetupScheduling.title": "计划",
  "actionSetupScheduling.rewardsAllocationDelay.duration.label": "奖励分配延迟",
  "actionSetupScheduling.voucherObjective.label": "优惠券目标",
  "actionSetupScheduling.voucherObjective.tooltip": "选择会员何时可以为此操作兑换优惠券。",
  "actionSetupScheduling.recurringType.label": "经常性类型",
  "actionSetupScheduling.recurringType.tooltip": "选择您的促销是重复使用还是一次性使用。",
  "actionSetupScheduling.recurringType.oneTime": "一次性使用",
  "actionSetupScheduling.recurringType.recurring": "经常性",
  "actionSetupScheduling.recurring.startDate.label": "开始日期",
  "actionSetupScheduling.recurring.startDate.tooltip": "会员可以从定义的开始日期开始获得此奖励。您可以更改开始日期，直到促销处于活动状态。",
  "actionSetupScheduling.recurring.endDate.label": "结束日期",
  "actionSetupScheduling.recurring.endDate.tooltip": "会员只能在您定义的结束日期之前获得此奖励。您可以更改结束日期，直到促销过期。",
  "actionSetupScheduling.recurring.repeatInterval.label": "间隔",
  "actionSetupScheduling.recurring.repeatInterval.tooltip": "选择您的促销是每日、每周还是每月重复，以及您希望它重复的频率。例如，每 2 个月。",
  "actionSetupScheduling.recurring.repeatInterval.options.daily": "天",
  "actionSetupScheduling.recurring.repeatInterval.options.weekly": "周",
  "actionSetupScheduling.recurring.repeatInterval.options.monthly": "月",
  "actionSetupScheduling.recurring.monthly.weekday.short.1": "一",
  "actionSetupScheduling.recurring.monthly.weekday.short.2": "二",
  "actionSetupScheduling.recurring.monthly.weekday.short.3": "三",
  "actionSetupScheduling.recurring.monthly.weekday.short.4": "四",
  "actionSetupScheduling.recurring.monthly.weekday.short.5": "五",
  "actionSetupScheduling.recurring.monthly.weekday.short.6": "六",
  "actionSetupScheduling.recurring.monthly.weekday.short.7": "日",
  "actionSetupScheduling.recurring.monthly.weekday.name.1": "星期一",
  "actionSetupScheduling.recurring.monthly.weekday.name.2": "星期二",
  "actionSetupScheduling.recurring.monthly.weekday.name.3": "星期三",
  "actionSetupScheduling.recurring.monthly.weekday.name.4": "星期四",
  "actionSetupScheduling.recurring.monthly.weekday.name.5": "星期五",
  "actionSetupScheduling.recurring.monthly.weekday.name.6": "星期六",
  "actionSetupScheduling.recurring.monthly.weekday.name.7": "星期日",
  "actionSetupScheduling.recurring.monthly.week.name.1": "第一",
  "actionSetupScheduling.recurring.monthly.week.name.2": "第二",
  "actionSetupScheduling.recurring.monthly.week.name.3": "第三",
  "actionSetupScheduling.recurring.monthly.week.name.4": "第四",
  "actionSetupScheduling.recurring.monthly.week.name.5": "最后",
  "actionSetupScheduling.recurring.monthly.calendarDates.label": "选择您希望奖励重复的日期：",
  "actionSetupScheduling.recurring.monthly.calendarDates.tooltip": "设置会员可以获得此奖励的日期。例如，每月的第一天。如果您选择 31，则奖励总是在每个月的最后一天。 ",
  "actionSetupScheduling.recurring.monthly.calendarDates.lastDaysTooltip": "仅当月份包含这一天时才有效",
  "actionSetupScheduling.recurring.monthly.calendarDates.lastDaysTooltipActive": "仅当它是该月的最后一天时才有效",
  "actionSetupScheduling.recurring.monthly.calendarDates.lastDaysTooltipActiveSelected": "仅当月份包含这一天或这是该月的最后一天时才有效",
  "actionSetupScheduling.recurring.monthly.weekDays.label": "选择周数和工作日数：",
  "actionSetupScheduling.recurring.monthly.weekDays.tooltip": "会员可以在选定日期获得此奖励。例如，每月的第一个星期一和星期四。",
  "actionSetupScheduling.recurring.monthly.isLastDayCb.label": "每月的最后一天",
  "actionSetupScheduling.recurring.timeRange": "从 {hour} 到 {hour}",
  "actionSetupScheduling.recurring.timeRange.tooltip": "定义会员可以获得此奖励的时间范围。",
  "actionSetupScheduling.recurring.wholeDayCb.label": "全天",
  "actionSetupScheduling.recurring.wholeDayCb.tooltip": "会员可以在定义的结束日期之前获得此奖励。您可以更改结束日期，直到促销过期。",
  "actionSetupScheduling.recurring.recurrenceSettings.label": "重复设置",
  "actionSetupScheduling.recurring.summary.label": "摘要",
  "actionSetupScheduling.nonRecurring.summary": "促销有效期从 {startDate} – {endDate} 有效。",
  "actionSetupScheduling.nonRecurring.summary.noSelection": "促销从 {specifyPromoValidity} 有效",
  "actionSetupScheduling.nonRecurring.summary.specifyPromoValidity": "指定促销有效期。",
  "actionSetupScheduling.recurring.summary.daily": "促销活动开始于 {startDate} 并结束于 {endDate}。促销活动在此期间有效：{intervalText}，{hours}。",
  "actionSetupScheduling.recurring.summary.dailyInterval.plural.zero": "每 {numberOfDays} 天",
  "actionSetupScheduling.recurring.summary.dailyInterval.plural.one": "每天",
  "actionSetupScheduling.recurring.summary.dailyInterval.plural.two": "每 {numberOfDays} 天",
  "actionSetupScheduling.recurring.summary.dailyInterval.plural.few": "每 {numberOfDays} 天",
  "actionSetupScheduling.recurring.summary.dailyInterval.plural.many": "每 {numberOfDays} 天",
  "actionSetupScheduling.recurring.summary.dailyInterval.plural.other": "每 {numberOfDays} 天",
  "actionSetupScheduling.recurring.summary.weekly": "促销活动开始于 {startDate} 并结束于 {endDate}。促销活动在此期间有效：{intervalText}，{selectedDays}，{hours}。",
  "actionSetupScheduling.recurring.summary.weeklyInterval.plural.zero": "每 {numberOfDays} 周",
  "actionSetupScheduling.recurring.summary.weeklyInterval.plural.one": "每周",
  "actionSetupScheduling.recurring.summary.weeklyInterval.plural.two": "每 {numberOfDays} 周",
  "actionSetupScheduling.recurring.summary.weeklyInterval.plural.few": "每 {numberOfDays} 周",
  "actionSetupScheduling.recurring.summary.weeklyInterval.plural.many": "每 {numberOfDays} 周",
  "actionSetupScheduling.recurring.summary.weeklyInterval.plural.other": "每 {numberOfDays} 周",
  "actionSetupScheduling.recurring.summary.monthly": "促销活动开始于 {startDate} 并结束于 {endDate}。促销活动在此期间有效：{intervalText}，{selectedDays}，{hours}。",
  "actionSetupScheduling.recurring.summary.monthlyInterval.plural.zero": "每 {numberOfDays} 月",
  "actionSetupScheduling.recurring.summary.monthlyInterval.plural.one": "每月",
  "actionSetupScheduling.recurring.summary.monthlyInterval.plural.two": "每 {numberOfDays} 月",
  "actionSetupScheduling.recurring.summary.monthlyInterval.plural.few": "每 {numberOfDays} 月",
  "actionSetupScheduling.recurring.summary.monthlyInterval.plural.many": "每 {numberOfDays} 月",
  "actionSetupScheduling.recurring.summary.monthlyInterval.plural.other": "每 {numberOfDays} 月",
  "actionSetupScheduling.recurring.summary.selectStartDate": "选择开始日期",
  "actionSetupScheduling.recurring.summary.selectEndDate": "选择结束日期",
  "actionSetupScheduling.recurring.summary.selectStartHour": "选择开始时间",
  "actionSetupScheduling.recurring.summary.selectEndHour": "选择结束时间",
  "actionSetupScheduling.recurring.summary.allDay": "全天",
  "actionSetupScheduling.recurring.summary.betweenHours": "之间的小时数：{startHour} - {endHour}",
  "actionSetupScheduling.recurring.summary.everyDay": "每天",
  "actionSetupScheduling.recurring.summary.everyWeekNumber": "每 {weekNumber} 周",
  "actionSetupScheduling.recurring.summary.followingDays.singleDay": "在以下日期：{weekNumber} {days}",
  "actionSetupScheduling.recurring.summary.followingDays.multipleDays": "在以下日期：{weekNumber} {days} 和 {lastDay}",
  "actionSetupScheduling.recurring.summary.followingDays.noSelection": "在以下日期：{weekNumber} {selectText}",
  "actionSetupScheduling.recurring.summary.selectDays": "选择可用日期",
  "actionSetupScheduling.recurring.summary.lastDayOfTheMonth": "当月最后一天",
  "actionSetupScheduling.recurringType.recurring.tzMismatchNotifiation": "促销根据以下时区设置：{timezone}。因此，对开始和结束时间的任何更改都将根据该时区进行考虑。",
  "actionSetupScheduling.promoValidity.label": "促销有效期",
  "actionSetupScheduling.promoValidity.tooltip": "会员可以在定义的时间期间内获得此奖励。",
  "actionSetupScheduling.validityType.label": "操作有效期",
  "actionSetupScheduling.validityType.tooltip": "选择此操作的有效期类型。",
  "actionSetupScheduling.validity.duration.label": "操作有效期长度",
  "actionSetupScheduling.validity.duration.tooltip": "设置此操作的有效期，从发送给会员之日起计算。",
  "actionSetupScheduling.validityFixedDate.label": "选择操作过期日期",
  "actionSetupScheduling.referralCta.label": "调用操作",
  "actionSetupScheduling.referralCta.tooltip": "当被推荐的朋友提供有效电子邮件地址并选择调用操作按钮时，会发生此操作。",
  "actionSetupScheduling.referralCta.sendViaEmailCb.label": "通过电子邮件发送代码。",
  "actionSetupScheduling.referralCta.displayInPopupCb.label": "在弹出框中显示代码。",
  "actionSetupScheduling.referralCta.sendViaEmail.emailCampaignId.label": "触发的电子邮件营销活动",
  "actionSetupScheduling.referralCta.sendViaEmail.emailCampaignId.tooltip": "触发的电子邮件向被推荐的朋友发送优惠券代码。选择您想要连接到此计划的相关触发的电子邮件营销活动。如果您在定义的市场中管理多种语言，请为每种语言选择一个营销活动。",
  "actionSetupScheduling.activation.label": "激活",
  "actionSetupTierFields.pointsEnabled.tooltip.spend": "您在此处输入的值将作为奖励添加到会员的业绩余额中。",
  "actionSetupTierFields.points.placeholder.points": "输入积分",
  "actionSetupTierFields.points.placeholder.spend": "输入业绩总和",
  "actionSetupTierFields.rewardPoolEnabledCb.label": "优惠券",
  "actionSetupTierFields.rewardPool.placeholder": "-- 选择优惠券 --",
  "actionSetupTierFields.exclusiveAccessEnabledCb.label": "专属访问",
  "actionSetupTierFields.exclusiveAccess.placeholder": "-- 选择访问权限 --",
  "actionSetupTierFields.statusUpgradeEnabledCb.label": "状态升级",
  "actionSetupTierFields.statusUpgrade.placeholder": "-- 选择升级类型 --",
  "multiCurrencyMinOrderFields.alert.message": "输入所有货币的最低订单金额。",
  "multiCurrencyMinOrderFields.minOrderMC.label": "最低订单金额",
  "multiCurrencyMinOrderFields.minOrderDisplayMC.label": "显示金额",
  "multiLangEmailCampaignIdField.emailCampaignId.label": "触发的电子邮件营销活动",
  "multiLangEmailCampaignIdField.emailCampaignId.placeholder": "- 选择模板 -",
  "referralContentReferrerForm.header": "会员",
  "referralContentReferrerForm.tooltip": "此表单会显示给会员的 Loyalty Wallet。请确保您的消息包含您设置的所有推荐限制。",
  "referralContentReferrerForm.text": "奖励文本",
  "referralContentReferrerForm.title1": "奖励标题",
  "referralContentReferrerForm.title2": "推荐链接文本",
  "referralContentReferrerForm.landingPageUrl.label": "推荐链接页面 URL",
  "referralContentReferrerForm.landingPageUrl.tooltip": "输入当朋友选择推荐链接时显示的推荐页面的 URL。",
  "referralContentReferrerForm.header.sharingChannels": "分享渠道",
  "referralContentReferrerForm.header.sharingChannels.tooltip": "选择您想要显示的分享渠道。",
  "referralContentReferrerForm.consentText.label": "同意声明文本",
  "referralContentReferrerForm.consentText.tooltip": "检查同意声明是否包含对您的推荐计划、流程的清晰描述，以及好友数据是否仅用于处理奖励，不会被保存。",
  "referralContentReferrerForm.consentLinkText.label": "条款链接文本",
  "referralContentReferrerForm.consentLinkUrl.label": "条款链接页面 URL",
  "referralContentRefereeForm.header": "好友",
  "referralContentRefereeForm.header.tooltip": "这是好友单击推荐链接后将看到的表单。确保您的消息包含已设置的所有限制。",
  "referralContentRefereeForm.title1": "奖励标题",
  "referralContentRefereeForm.text1": "奖励文本",
  "referralContentRefereeForm.title2": "请求电子邮件标题",
  "referralContentRefereeForm.text2": "请求电子邮件文本",
  "referralContentRefereeForm.inputFieldPlaceholder": "电子邮件字段",
  "referralContentRefereeForm.consentText.label": "同意声明文本",
  "referralContentRefereeForm.consentText.tooltip": "检查同意声明是否包含对您的推荐计划、流程的清晰描述，以及好友数据是否仅用于处理奖励，不会被保存。",
  "referralContentRefereeForm.consentLinkText": "条款链接文本",
  "referralContentRefereeForm.consentLinkUrl": "条款链接页面 URL",
  "promotionType.oneTime.name": "单次使用优惠",
  "promotionType.oneTime.tooltip": "会员只能兑换一次此优惠。",
  "promotionType.multiUse.name": "多次使用优惠",
  "promotionType.multiUse.tooltip": "会员可以在有效期内多次兑换此优惠。",
  "referralCodesLinitOptions.none.name": "无限制",
  "referralCodesLinitOptions.begOfYear.name": "每年代码数量限制为：",
  "referralCodesLinitOptions.begOfYear.tooltip": "限制从日历开始追溯生效。",
  "referralRewardLimitOptions.none.name": "无限制",
  "referralRewardLimitOptions.begOfYear.name": "每个会员的奖励限制为",
  "referralRewardLimitOptions.begOfYear.tooltip": "限制从日历开始追溯生效。",
  "validityType.limitedFromEarn.name": "该操作自发送给会员之日起有效期为若干天。",
  "validityType.fixedDate.name": "该操作对所有会员在特定日期前有效。",
  "actionValidator.name.presence.isReferralAction": "输入程序名称。",
  "actionValidator.internalName.presence.isReferralAction": "输入程序内部名称。",
  "actionValidator.name.presence.notReferralAction": "输入操作名称。",
  "actionValidator.internalName.presence.notReferralAction": "输入操作内部名称。",
  "actionValidator.name.exclusionIgnoreCase": "此名称已存在。输入唯一名称。",
  "actionValidator.promotion.catalogSelection.actionCatalogSelection": "需要选择目录。",
  "actionValidator.constraints.apiTriggers.presence": "选择外部忠诚度事件。",
  "actionValidator.constraints.minOrder.presence": "输入所有货币的最低订单金额。",
  "actionValidator.constraints.minOrderMC.multiLangField": "输入所有货币的最低订单金额。",
  "actionValidator.constraints.blockExternalLink.text.presence": "输入页面 URL 文本。",
  "actionValidator.constraints.blockExternalLink.url.presence": "输入外部页面 URL。",
  "actionValidator.constraints.blockExternalLink.url.url": "输入有效的登录页面 URL。",
  "actionValidator.constraints.market.presence": "输入市场。",
  "actionValidator.reward.value.actionSingleReward": "输入缺失信息。",
  "actionValidator.constraints.isBlockMessage.isBlockMessage.emptyTokenMessage": "以下字段为必填项：{fieldName}。",
  "actionValidator.constraints.url": "以下字段必须包含有效的 URL：{fieldName}。",
  "actionValidator.constraints.referralLimitations.codes.amount.presence": "输入推荐限制。",
  "actionValidator.constraints.referralContent.referrer.title.presence": "输入推荐标题。",
  "actionValidator.constraints.referralContent.referrer.text.emptyTokenMessage": "输入推荐文本。",
  "actionValidator.constraints.referralContent.referrer.subtitle.presence": "输入推荐链接文本。",
  "actionValidator.constraints.referralContent.referrer.landingPageUrl.presence": "输入推荐页面 URL。",
  "actionValidator.constraints.referralContent.referrer.landingPageUrl.url": "输入推荐页面的有效 URL。",
  "actionValidator.constraints.referralContent.referrer.consentText.presence": "输入同意声明文本。",
  "actionValidator.constraints.referralContent.referrer.consentLinkText.presence": "输入条款链接文本。",
  "actionValidator.constraints.referralContent.referrer.consentLinkUrl.presence": "输入条款链接页面 URL。",
  "actionValidator.constraints.referralContent.referrer.consentLinkUrl.url": "输入有效的条款链接页面 URL",
  "actionValidator.constraints.referralContent.referee.title.presence": "输入推荐标题。",
  "actionValidator.constraints.referralContent.referee.text.presence": "输入奖励文本。",
  "actionValidator.constraints.referralContent.referee.secondaryTitle.presence": "输入推荐电子邮件标题。",
  "actionValidator.constraints.referralContent.referee.inputFieldPlaceholder.presence": "输入电子邮件提示文本。",
  "actionValidator.constraints.referralContent.referee.secondaryText.presence": "输入推荐电子邮件文本。",
  "actionValidator.constraints.referralContent.referee.consentText.presence": "输入同意声明文本。",
  "actionValidator.constraints.referralContent.referee.consentLinkText.presence": "输入条款链接文本。",
  "actionValidator.constraints.referralContent.referee.consentLinkUrl.presence": "输入条款链接页面 URL。",
  "actionValidator.constraints.referralContent.referee.consentLinkUrl.url": "输入有效的条款链接页面 URL",
  "actionValidator.constraints.referralContent.referee.ctaText.presence": "输入兑换文本。",
  "actionValidator.constraints.referralContent.referee.secondaryConsentText.presence": "输入次要同意声明文本。",
  "actionValidator.constraints.referralContent.referee.secondaryConsentLinkText.presence": "输入条款链接文本。",
  "actionValidator.constraints.referralContent.referee.secondaryConsentLinkUrl.presence": "输入条款链接页面 URL。",
  "actionValidator.constraints.referralContent.referee.secondaryConsentLinkUrl.url": "输入有效的条款链接页面 URL",
  "actionValidator.constraints.rcheduling.promoValidity.dateRange.messageEmpty": "输入促销有效期日期。",
  "actionValidator.constraints.rcheduling.promoValidity.dateRange.messageRangeNotValid": "促销至少需要 10 分钟。",
  "actionValidator.constraints.scheduling.promoValidity.dateRange.selectedDateNotValid": "促销有效期无效。",
  "actionValidator.constraints.rscheduling.validity.duration.presence": "输入大于零的操作有效期。",
  "actionValidator.constraints.rscheduling.validity.duration.numericality.notInteger": "输入大于零的操作有效期。",
  "actionValidator.constraints.rscheduling.validity.duration.numericality.notGreaterThan": "输入大于零的操作有效期。",
  "actionValidator.constraints.scheduling.validityFixedDate.presence": "输入过期日期",
  "actionValidator.constraints.scheduling.referralCta.atLeastOneSelected": "需要 CTA 操作",
  "actionValidator.constraints.scheduling.recurring.startDate.presence": "输入开始日期",
  "actionValidator.constraints.scheduling.recurring.endDate.presence": "输入结束日期",
  "actionValidator.constraints.scheduling.recurring.endDate.rangeInvalid": "结束日期不能早于选定开始日期。",
  "actionValidator.constraints.scheduling.recurring.endHour.rangeInvalid": "选择有效的结束时间。结束时间必须晚于开始时间。",
  "actionValidator.constraints.scheduling.recurring.weekDays.presence": "您必须选择星期几",
  "actionValidator.constraints.scheduling.recurring.monthDays.presence": "您必须选择月份中的一天",
  "actionValidator.constraints.emailCampaignId.presence": "输入触发的电子邮件营销活动。",
  "actionValidator.constraints.notDefault.validateNonMember": "定义加入奖励。",
  "actionValidator.constraints.notDefault.notValidateNonMember": "为至少一个层级定义奖励。",
  "actionValidator.constraints.notDefault.reward.value.actionRewardSpecificTier": "为朋友定义奖励。",
  "actionValidator.constraints.currencies.minOrderMC.currency.presence": "输入所有货币的最低订单金额。",
  "form.Steps.actionSettings.title.referral": "程序设置",
  "form.steps.actionSettings.title": "操作设置",
  "form.steps.rewardSettings.title": "奖励设置",
  "form.steps.contentCreation.title": "创建内容",
  "form.steps.scheduling.title": "计划",
  "form.steps.actionSettings.defaultJoin.title": "缺省设置",
  "specialTierRewardSettings.all.name": "所有层级设置相同",
  "specialTierRewardSettings.non.name": "加入奖励",
  "specialTierRewardSettings.guest.name": "好友",
  "multiplyPoints.options.double.name": "双倍积分",
  "multiplyPoints.options.triple.name": "三倍积分",
  "multiplySpend.options.double.name": "双倍业绩",
  "multiplySpend.options.triple.name": "三倍业绩",
  "statusUpgrade.options.nextTier.name": "升级到下一层级",
  "enableInSmartBox.options.yes.name": "自动优先处理并分配此操作。",
  "enableInSmartBox.options.no.name": "不自动优先处理并分配此操作。",
  "voucherObjective.options.reward.name": "奖励（客户在购买获得批准后获得）",
  "voucherObjective.options.trigger.name": "触发（客户立即获得并可在购买时兑换）",
  "activate.options.true": "激活操作",
  "activate.options.false": "取消激活操作",
  "activate.promotion.options.true": "激活促销",
  "activate.promotion.options.false": "取消激活促销",
  "defaultJoinMessageNoReward": "立即加入我们的忠诚度计划，并在您未来的购买中赚取积分。",
  "selectedPromotion.options.event.name": "销售/事件促销",
  "selectedPromotion.options.catalog.name": "目录促销",
  "actionDashboard.overviewLinkText.referral": "转到推荐操作",
  "actionDashboard.editLinkText": "编辑计划",
  "actionDashboard.launchedAt": "计划于 {time} 启动",
  "defaultJoinMessageWithReward": "立即加入我们的忠诚度计划，获得以下奖励并在您未来的购买中赚取积分：{{rewardToken}}",
  "actions.notification.purchase": "要激活采购操作，请{helpLink}您的联系人。{learnMoreLink}。",
  "actions.notification.engagement": "要激活参与操作，请{helpLink}您的联系人。{learnMoreLink}。",
  "actions.notification.join": "缺省加入操作将在激活并启动计划后自动执行。附加加入操作需要设置为 {helpLink}。{learnMoreLink}。",
  "actionSetup.alert.activeMustDeactivate.deactivateText": "将其取消激活",
  "actionSetupContentCreation.editSide.title.tooltip.default": "如果出现系统或网络错误，缺省消息将替换原始消息令牌。定义的 {message} {cta text} {cta url} 令牌将显示在智能模块和忠诚度钱包中。",
  "actionSetupContentCreation.editSide.title.tooltip.join": "定义的 {message} {cta text} {cta url} 令牌将显示在智能块和忠诚度钱包中。如果没有定义的加入消息，则会显示缺省消息。",
  "actionSetupContentCreation.editSide.title.tooltip.other": "定义的 {message} {cta text} {cta url} 令牌将显示在智能块和忠诚度钱包中。您可以单独使用这些令牌，也可以在营销活动编辑器中将其与内容模块一起使用。",
  "actionSetupContentCreation.previewSideTitleTooltip.tokens": "以下是 {loyalty tokens} 在电子邮件内容块中的显示方式示例。实际设计可能因电子邮件设计而异。",
  "actionSetupLoyaltyMessagePreviewEmail.notification.tokens": "以下是 {loyalty tokens} 在电子邮件内容块中的显示方式示例。实际设计可能因电子邮件设计而异。",
  "actionSetupRewards.pointsType.popup.message": "如果您更改积分类型，则“多积分”选项将被移除，因为等级 {tiers} 的倍数奖励与您选择的积分类型不兼容！如果您想给予多个积分，可以更改积分类型并再次选择“多积分”。",
  "actionSetupScheduling.recurring.summary.followingDays.daySuffix.ordinal.zero": "第 {day} 天",
  "actionSetupScheduling.recurring.summary.followingDays.daySuffix.ordinal.one": "第 {day} 天",
  "actionSetupScheduling.recurring.summary.followingDays.daySuffix.ordinal.two": "第 {day} 天",
  "actionSetupScheduling.recurring.summary.followingDays.daySuffix.ordinal.few": "第 {day} 天",
  "actionSetupScheduling.recurring.summary.followingDays.daySuffix.ordinal.many": "第 {day} 天",
  "actionSetupScheduling.recurring.summary.followingDays.daySuffix.ordinal.other": "第 {day} 天",
  "actionSetupScheduling.recurring.summary.week.name.1": "第一",
  "actionSetupScheduling.recurring.summary.week.name.2": "第二",
  "actionSetupScheduling.recurring.summary.week.name.3": "第三",
  "actionSetupScheduling.recurring.summary.week.name.4": "第四",
  "actionSetupScheduling.recurring.summary.week.name.5": "最后一个"
}
